import { Tabs } from '@tempmee/react';
import { AuthLeftPanel, ProfessionalsTab, TESTIMONIALS, VALUE_PROPS } from '../shared';
import { SignUpForm } from './SignUpForm';

const HEADLINE = { lineOne: 'The Right Fit', lineTwo: 'Right Now' } as const;
const FORM_WIDTH = 448;

export const SignUpPage = () => (
  <div className="auth-page-layout" data-testid="signup-page">
    <div className="auth-page-left">
      <AuthLeftPanel headline={HEADLINE} valueProps={VALUE_PROPS} testimonials={TESTIMONIALS} />
    </div>
    <div className="auth-page-right">
      <div style={{ width: FORM_WIDTH, maxWidth: '100%' }}>
        <Tabs defaultValue="offices">
          <Tabs.List style={{ justifyContent: 'center', gap: 16 }}>
            <Tabs.Tab data-cy="tab-offices" value="offices" style={{ fontSize: 26 }}>
              Offices
            </Tabs.Tab>
            <Tabs.Tab data-cy="tab-professionals" value="professionals" style={{ fontSize: 26 }}>
              Professionals
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="offices">
            <SignUpForm />
          </Tabs.Panel>
          <Tabs.Panel value="professionals">
            <ProfessionalsTab />
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  </div>
);
